// Email configuration for production deployment
// This file can be modified on the server without rebuilding

export interface EmailConfig {
  provider: 'smtp2go' | 'sendgrid' | 'mailgun' | 'itpac' | 'mock';
  smtp: {
    host: string;
    port: number;
    secure: boolean;
    user: string;
    pass: string;
  };
  fromEmail: string;
  apiKey?: string;
}

// Default configuration - can be overridden by server config
export const defaultEmailConfig: EmailConfig = {
  provider: 'itpac',
  smtp: {
    host: 'mail.itpac.tech',
    port: 465,
    secure: true,
    user: 'admin@itpac.tech',
    pass: 'Q*RIwv9bXpk%'
  },
  fromEmail: 'noreply@itpac.tech'
};

// Function to load configuration from server or use defaults
export const getEmailConfig = (): EmailConfig => {
  // Try to load from window object (set by server-side script)
  if (typeof window !== 'undefined' && (window as any).EMAIL_CONFIG) {
    return { ...defaultEmailConfig, ...(window as any).EMAIL_CONFIG };
  }
  
  // Fallback to environment variables (for development)
  if (process.env.REACT_APP_EMAIL_PROVIDER) {
    return {
      provider: (process.env.REACT_APP_EMAIL_PROVIDER as any) || 'smtp2go',
      smtp: {
        host: process.env.REACT_APP_SMTP_HOST || 'mail.smtp2go.com',
        port: parseInt(process.env.REACT_APP_SMTP_PORT || '2525'),
        secure: process.env.REACT_APP_SMTP_SECURE === 'true',
        user: process.env.REACT_APP_SMTP_USER || 'noreply@goodbyemalaria.com',
        pass: process.env.REACT_APP_SMTP_PASS || 'iNeOj7aV2xI6Jqql'
      },
      fromEmail: process.env.REACT_APP_FROM_EMAIL || 'noreply@goodbyemalaria.com',
      apiKey: process.env.REACT_APP_EMAIL_API_KEY
    };
  }
  
  // Use default configuration
  return defaultEmailConfig;
};
